import { useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";
import { Bot, ExternalLink, Copy, Check, MessageSquare } from "lucide-react";
import { toast } from "sonner";

export function MCPSettings() {
  const { user } = useAuth();
  const [copiedLink, setCopiedLink] = useState(false);

  const handleCopyLink = () => {
    navigator.clipboard.writeText("https://chatgpt.com/g/g-6a3addaa2cc08191892da92fea5073a5-uptimewing");
    setCopiedLink(true);
    toast.success("GPT link copied to clipboard!");
    setTimeout(() => setCopiedLink(false), 2000);
  };

  return (
    <div className="space-y-8 select-none font-mono text-xs">
      {/* Header section */}
      <div>
        <h2 className="text-xl font-black uppercase tracking-tight mb-1 text-foreground">GPT Custom Assistant</h2>
        <p className="text-xs text-muted-foreground font-bold uppercase leading-relaxed max-w-2xl">
          Operate UptimeWing directly from ChatGPT without leaving your AI workspace.
        </p>
      </div>

      <div className="border-4 border-black p-6 bg-white shadow-[6px_6px_0_0_#000] space-y-6">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 bg-primary/10 border-2 border-black flex items-center justify-center text-primary">
            <MessageSquare className="w-5 h-5" />
          </div>
          <div>
            <h3 className="text-sm font-black uppercase text-foreground">UptimeWing Custom GPT</h3>
            <p className="text-[10px] text-zinc-500 font-bold uppercase">Authorized custom assistant connection</p>
          </div>
        </div>

        <p className="text-zinc-650 uppercase font-semibold leading-relaxed text-[10px] border-t border-b border-zinc-100 py-3">
          Ask questions like "what broke today?", "why is checkout slow?", or "check SSL expiry logs" directly inside ChatGPT. Your conversations link securely with your telemetry endpoints.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 pt-2">
          <a
            href="https://chatgpt.com/g/g-6a3addaa2cc08191892da92fea5073a5-uptimewing"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1"
          >
            <Button className="w-full h-11 rounded-none border-2 border-black bg-[#FFFF00] text-black hover:bg-black hover:text-white font-black uppercase text-xs shadow-[3px_3px_0_0_#000]">
              Open ChatGPT Custom Assistant <ExternalLink className="w-4 h-4 ml-1.5 inline" />
            </Button>
          </a>
          <Button
            onClick={handleCopyLink}
            variant="ghost"
            className="h-11 rounded-none border-2 border-black bg-white text-black hover:bg-zinc-50 font-black uppercase text-xs px-6 shadow-[3px_3px_0_0_#000]"
          >
            {copiedLink ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />} Copy Link
          </Button>
        </div>
      </div>
    </div>
  );
}
